import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from '@app/routes/router';
import { AppProviders } from '@app/providers/AppProviders';
import { config } from '@shared/config';
import { injectProductTypeCssVars } from '@shared/constants/product';
import '@i18n/i18n';
import './index.css';

// Inject product type CSS custom properties once at startup so any component
// or stylesheet can reference var(--product-type-avcs), etc.
injectProductTypeCssVars();

async function bootstrap() {
  if (__ENABLE_MOCKS__ && config.apiSource !== 'SERVER') {
    const { worker } = await import('@mocks/msw/browser');
    await worker.start({
      onUnhandledRequest: config.apiSource === 'REGISTRY' ? 'warn' : 'bypass',
    });
  }

  if (__ENABLE_MOCKS__ && config.apiSource === 'MSW') {
    const { MockSignalRHub } = await import('@mocks/signalr/mockSignalR');
    const { setSignalRInstance } = await import('@api/client/signalRInstance');
    const hub = new MockSignalRHub();
    setSignalRInstance(hub);
    await hub.start();
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </StrictMode>,
  );
}

bootstrap();
